<template>
	<div>
		<div class="empty-img" v-if="data.length==0">
		  <img src="./collect.png"/>
		  <p>无收藏</p>
    </div>
		<div class="me-fav">
			<ul class="me-fav-items f-cbli" v-dt-infinite-scroll="getData">
				<!-- 三种状态继续、开始、查看分别为1,2,3-->
				<li class="me-fav-item me-fav-item-3" v-for="(item,index) in data">
					<div class="me-fav-pic f-img-box">
						<img :src="item.cover_img">
						<div class="me-fav-pic-text">{{countStatus(item)}}</div>
					</div>
					<div class="me-fav-content">
						<div class="me-fav-title o1">{{item.course_title}}</div>
						<div class="me-fav-info f-cb">
							<div class="me-fav-last">上次学习 <span v-if="item.last_stu_time == 0">无</span><span v-else>{{tools.timestampConversion(item.last_stu_time)}}</span></div>
							<div class="me-fav-rate">已学{{item.schedule}}</div>
						</div>
						<div class="me-fav-links f-cb">
							<div class="me-fav-cancel" @click="cancelFav(index)">取消收藏</div>
							<div class="me-fav-continue">
								<div v-if="getStatus(item) == 3" class="me-fav-continue-3" @click="to('/lesson-detail/'+item.course_id)">查看课程>></div>
								<div v-if="getStatus(item) == 2" class="me-fav-continue-2" @click="to('/lesson-chapter/'+item.course_id+'/'+item.section_id)">开始学习>></div>
								<div v-if="getStatus(item) == 1" class="me-fav-continue-1" @click="to('/lesson-chapter/'+item.course_id+'/'+item.section_id)">继续学习>></div>
								<!-- <div class="me-fav-continue-1">继续学习>></div>
								<div class="me-fav-continue-2">开始学习>></div>
								<div class="me-fav-continue-3">查看课程>></div> -->
							</div>
						</div>
					</div>
				</li>
				<!-- <li class="me-fav-item me-fav-item-3">
					<div class="me-fav-pic f-img-box">
						<img src="../index/lesson-pic.png">
						<div class="me-fav-pic-text">6天后到期</div>
					</div>
					<div class="me-fav-content">
						<div class="me-fav-title o1">JavaScript权威指南</div>
						<div class="me-fav-info f-cb">
							<div class="me-fav-last">上次学习 2018.9.10</div>
							<div class="me-fav-rate">已学56%</div>
						</div>
						<div class="me-fav-links f-cb">
							<div class="me-fav-cancel">取消收藏</div>
							<div class="me-fav-continue">
								<div class="me-fav-continue-1">继续学习>></div>
								<div class="me-fav-continue-2">开始学习>></div>
								<div class="me-fav-continue-3">查看课程>></div>
							</div>
						</div>
					</div>
				</li> -->
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				data:[]
			}
		},
		methods:{
			to(name){
				this.$router.push(name);
			},
			countStatus(item){
				var open_status=item.open_status,
					stime=item.start_time,
					etime=item.end_time;
				if(open_status == 0){
					return '暂不开放'
				}
				else if(open_status == 2){
					return '无限期'
				}
				else{//开放课程，检查时效
					var nowTimestamp=new Date().getTime()/1000;
					if(nowTimestamp < stime){
						//未到开放时间
						return '尚未开课'
					}
					if(nowTimestamp > etime){
						//超过开放时间
						return '已过期'
					}
					if(nowTimestamp > stime && nowTimestamp < etime){
						return this.tools.timestampToText(etime)+"到期";
					}
				}

			},
			getStatus(item){
				var isEnroll=item.is_baoming,
					open_status=item.open_status,
					stime=item.start_time,
					etime=item.end_time,
					course_id=item.course_id,
					schedule=item.schedule
				//isEnroll 0未报名 1报名
				//return 3查看课程 1继续学习 2开始学习
				//open_status 0不开放 1限时开放 2开放
				var nowTimestamp=new Date().getTime()/1000;
				if(open_status == 0 || isEnroll == 0){//如果课程不开放或是没报名
					return 3
				}
				else if(open_status == 1){//限时开放的课程 查看时效
					if(nowTimestamp > stime && nowTimestamp < etime){
						if(schedule == '0%'){//进度为0
							return 2;
						}
						else{
							return 1
						}

					}
					else{
						return 3;
					}
				}
				else if(open_status == 2){//开放课程
					if(schedule == '0%'){
						return 2
					}
					else{
						return 1
					}
				}
			},
			getData(page){
			  var length=10;
			  return new Promise((resolve,reject)=>{
          this.$api.get("",{
              api:"/v1/my/myCollect",
              user_type:this.tools.getStorage('user_type'),
              page,
              len: length
            },res => {
              var data=res.data;
              this.data=this.data.concat(data);
              if(data.length<length){
                reject();
              }
              else{
                resolve();
              }
            })
        })
			},
			cancelFav(index){
				this.$messagebox.confirm("确定要取消收藏吗？").then(()=>{
					this.$api.get("",{
						api:"/v1/course/cancel_collect",
						user_type:this.tools.getStorage("user_type"),
						id:this.data[index].course_id
					},res=>{
						this.isFav=false;
						this.data.splice(index,1);
						this.$toast("取消收藏成功！");
					})
				})
			}
		}
	}
</script>

<style>
	.me-fav-items{
		padding-top:0.133rem;
	}
	.me-fav-item{
		margin:0.4rem 0.4rem 0 0.4rem;
	}
	.me-fav-pic{
		position: relative;
		float:left;
		width:2.88rem;
		height:2.106rem;
		border-radius: 0.133rem;
	}
	.me-fav-pic-text{
		position: absolute;
		bottom:0;
		left:0;
		width:100%;
		height:0.666rem;
		color:#fff;
		background: rgba(0,0,0,0.5);
		text-align: center;
		line-height:0.666rem;
		font-size: 0.346rem;
	}
	.me-fav-content{
		float:right;
		width:6.08rem;
	}
	.me-fav-title{
		margin-top:0.133rem;
		color:#333;
		font-size: 0.426rem;
	}
	.me-fav-info{
		margin-top:0.2rem;
		color:#999;
		font-size: 0.346rem;
		line-height:0.346rem;
	}
	.me-fav-last{
		float:left;
	}
	.me-fav-rate{
		float:right;
	}
	.me-fav-links{
		margin-top:0.453rem;
		font-size: 0.426rem;
		line-height: 0.426rem;
	}
	.me-fav-cancel{
		float:left;
		color:#ccc;
	}
	.me-fav-continue{
		float:right;
	}
	.me-fav-continue-1,
	.me-fav-continue-2,
	.me-fav-continue-3{
		/*display: none;*/
	}
	.me-fav-continue-1,
	.me-fav-continue-2{
		color:#EC6D3A;
	}
	.me-fav-continue-3{
		color:#3192E0;
	}
	.me-fav-item-1 .me-fav-continue-1{
		/*display: block;*/
	}
	.me-fav-item-2 .me-fav-continue-2{
		/*display: block;*/
	}
	.me-fav-item-3 .me-fav-continue-3{
		/*display: block;*/
	}
</style>



// WEBPACK FOOTER //
// src/components/me-fav/me-fav.vue